<template>
  <div>
    <el-carousel :interval="5000" arrow="always" height="496px" indicator-position="none">
      <el-carousel-item v-for="(item,index) in homeScrollHotel" :key="item.pic">
        <div class="carousel-caption d-flex justify-content-between">
          <div class="pl-4 h5">{{item.title}}</div>
          <div class="pr-3 h5">
            <span class="text-warning h3">{{index+1}}</span> / {{homeScrollHotel.length}}
          </div>
        </div>
        <img class="w-100 h-100" :src="ImgPreUrl+item.pic"
             @click="$router.push('/index_hotel/hotel_detail/'+item.custom)">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    name: 'EleCarousel',
    props: {
      homeScrollHotel: {
        type: Array,
        default: () => {
          return [];
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .carousel-caption{
    background: rgba(0,0,0,.3);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    color: white;
    padding: 10px 0;
    justify-content: space-between;
  }
</style>
